export default __webpack_public_path__ + "static/media/sonakontekstis_et.14cae214.png";